import React from "react";
import { Navigate } from "react-router-dom";
import AuthLoader from "./AuthLoader";

const isAuthenticated = () => {
  // Check if a valid token exists in localStorage
  return !!localStorage.getItem("token") || !!sessionStorage.getItem("token");
};

const AuthRoute = ({ element: Component, authChecking, ...rest }) => {
  if (authChecking) return <AuthLoader />;
  return isAuthenticated() ? Component : <Navigate to="/login" />;
};

export default AuthRoute;
